/**
 * 通过服务查询自定义标签数据
 * @param applyId/claimId:businessId
 * @param caseId:model
 * @param regionId  执行的区块划分
 * @return
 */

/**
 * 注入代码hook自定义组件实现逻辑
 * 1.统一所有使用自定义组件的页面方法，通过当前VuePage实例内特定方法的方式触发组件初始化行为和校验提交行为
 * 统一两个方法 initElement和pageSubmit
 * 当前版本先简单实现一个人为控制的伪代理
 * TODO 后续优化版本需要实现真正的AppJs-Hook的方式
 */

import {cookieInvalid, getFileDownloadUrl, BASE_SERVER} from '../api';
import {getStore} from '../storage';

const preUploadUrl = `${BASE_SERVER}/api/v1/file/generatePresignedInfo`
const verifyFileUrl = `${BASE_SERVER}/api/v1/file/verifyFile`
/**
 * 自定义组件集群初始化（单页面）
 * 必须在mounted回调中使用--每个自定义组件必须制定统一ref名称：custom_area_xx
 * @param pageInstance(当前页面)
 */
export const initElement = (pageInstance, elementData, callback) => {
  const ctInstanceList = [];
  // 使用refs来处理逻辑
  if (pageInstance.$refs) {
    const childrens = pageInstance.$refs;
    Object.keys(childrens).forEach((refKey, idx) => {
      if (checkCustomChild(refKey)) {
        ctInstanceList.push(childrens[refKey]);
        // 初始化加载状态
        pageInstance.$refs[refKey].isFinished = false;
        pageInstance.$refs[refKey].isError = false;
      }
    });

    if (ctInstanceList && ctInstanceList.length > 0) {
      // let formId;
      // let businessId, model, businessType, isAudit;
      // let regionIds = [];
      // businessId和businessType可能会出现多个不一样的情况，目前先不处理，业务上不会出现
      // businessId = ctInstanceList[0].$options.propsData.params.businessId;
      // model = ctInstanceList[0].$options.propsData.params.model;
      // businessType = ctInstanceList[0].$options.propsData.params.businessType;
      // isAudit = ctInstanceList[0].$options.propsData.params.isAudit;
      // ctInstanceList.forEach(instance => {
      //   regionIds.push(instance.$options.propsData.regionId);
      // });
      // formId = ctInstanceList[0].$options.propsData.params.formId;

      // 获取服务配置的区域划分数据
      renderCustomData(pageInstance, elementData, callback);
      // queryBatchElement(formId).then(res => {
      //   if (res.code == 200 && res.data) {
      //     // 动态渲染数据
      //     renderCustomData(pageInstance, res.data, callback);
      //   }
      // }, err => {
      //   setPageInstanceDataValue(pageInstance, {
      //     isFinished: true,
      //     isError: true
      //   });
      // });
    }
  }
  // $refs.$chlidren(array)=包含组件
  // $refs.$options.propsData=外部传递的参数
  // console.log('refInstance', refInstance,refInstance.$options.propsData)
};

/**
 *  自定义组件集群所在页面发生提交行为时的回调执行逻辑
 *  @param pageInstance(当前页面)
 *  @return {{tagRegionExt, valid}}
 */
export const pageSubmit = (pageInstance, valid = true) => {
  // pageInstace一个一个调用当前页面的custom-area的createParams
  if (pageInstance) {
    return getCustomValues(pageInstance, valid);
  }
  return {};
};

/**
 * 展示当前页面所有自定义区域内的错误信息校验
 * @param pageInstance
 */
export const showValidate = pageInstance => {
  if (pageInstance) {
    showTagElementValidate(pageInstance);
  }
};

/**
 *
 * @param targetTitles 自定义组件区域的title组件ref实例
 */
export const getTargetTitles = targetTitles => {
  if (
    targetTitles &&
    Object.prototype.toString.call(targetTitles) === '[object Array]' &&
    targetTitles.length > 0
  ) {
    const list = [];
    targetTitles.forEach(refItem => {
      list.push({
        ...refItem.getTitleInfo(),
        uid: refItem._uid
      });
    });
    list.sort((a, b) => {
      a < b;
    });
    return list;
  }
  return [];
};

const showTagElementValidate = pageInstance => {
  Object.keys(pageInstance.$refs).forEach(refKey => {
    if (checkCustomChild(refKey)) {
      pageInstance.$refs[refKey].showValidate();
    }
  });
};

/**
 *
 * @param pageInstance
 * @param validRules 是否开启校验不成功就不获取的模式  true开启|false关闭
 * @return {{tagRegionExt: {}, valid: boolean}}
 */
const getCustomValues = (pageInstance, validRules) => {
  const tagRegionExt = {};
  let valid = true;
  Object.keys(pageInstance.$refs).forEach((refKey, idx) => {
    if (checkCustomChild(refKey)) {
      const result = pageInstance.$refs[refKey].createParams();
      if (result.valid || !validRules) {
        tagRegionExt[pageInstance.$refs[refKey].$options.propsData.regionId] =
          result.value;
      } else {
        valid = result.valid;
      }
    }
  });
  return {tagRegionExt, valid};
};

const renderCustomData = (pageInstance, elementData, callback) => {
  // 这里的child都是ref实例
  if (pageInstance && elementData) {
    Object.keys(pageInstance.$refs).forEach((refKey, idx) => {
      if (pageInstance.$refs[refKey] && checkCustomChild(refKey)) {
        Object.keys(elementData).forEach(regionId => {
          const isArr = Array.isArray(pageInstance.$refs[refKey]);
          const node = isArr
            ? pageInstance.$refs[refKey][0]
            : pageInstance.$refs[refKey];
          if (!node) {
            return;
          } // 解决虚拟DOM不存在情况
          node.isFinished = true;
          if (regionId == node.$options.propsData.regionId) {
            node.elements = elementData[regionId].elements;
            node.configForm = elementData[regionId].configForm || {};
            node.elementDataList = elementData[regionId].elementDataList;
            node.processLinkConfig = elementData[regionId].processLinkConfig;
            node.sortData();
            node.setRelationRegionVsi();
          }
        });
      }
    });
    pageInstance.$nextTick(() => {
      callback && callback();
    });
  }
};

const setPageInstanceDataValue = (pageInstance, dataList) => {
  if (pageInstance && dataList) {
    Object.keys(pageInstance.$refs).forEach((refKey, idx) => {
      if (pageInstance.$refs[refKey]) {
        Object.keys(dataList).forEach(key => {
          pageInstance.$refs[refKey][key] = dataList[key];
        });
      }
    });
  }
};

const checkCustomChild = refKey => refKey && refKey.indexOf('custom_area') != -1;

export function preview(item, applyMattersId = '', enable = false) {
  let saveId = item.saveId ? item.saveId : '';
  const params = {
    fileId: saveId,
    business: getStore('business'),
    enable
  };
  if (applyMattersId) params.applyMattersId = applyMattersId;
  getFileDownloadUrl(params).then(res => {
    if (res && res.code && res.code == 200 && res.data) {
      window.open(res.data);
    } else {
      console.error('', '预览文件:' + item.fileName + '发生错误，请重试');
    }
  });
}

export const hookFunctionObject = {
  common: {
    rtcPrefix: '/brt-admin-scene'
  },
  upload: {
    downCallBack: preview,
    fileDownUrl: '/brt-admin-scene/api/v1/upload/url',
    classType: 'brt-tj-custom',
    preUrl: preUploadUrl,
    verifyFileUrl: verifyFileUrl,
    errorCallBack: (err) => {
      const httpStatus = err && (err.httpStatus || '');
      const code = err && (err.code || '');
      cookieInvalid(httpStatus, code, false);
    }
  }
};

export const hookFunctionObject_tj = {
  common: {
    rtcPrefix: '/brt-mediate-scene'
  },
  upload: {
    downCallBack: preview,
    fileDownUrl: '/brt-mediate-scene/api/v1/upload/url',
    classType: 'brt-tj-custom',
    preUrl: preUploadUrl,
    verifyFileUrl: verifyFileUrl,
    errorCallBack: (err) => {
      const httpStatus = err && (err.httpStatus || '');
      const code = err && (err.code || '');
      cookieInvalid(httpStatus, code, false);
    }
  }
}
